import React from 'react';
import type { Hero } from 'types';

import { RichText } from '@leafwell/components';
import HeadingBody from './heading-body';

const HeroResearch: React.FC<{ hero?: Hero }> = ({
  hero: { subTitle, title, description },
}) => (
  <>
    <HeadingBody level="6" className="lg:col-span-full" title={subTitle} />
    <HeadingBody className="lg:col-span-4 font-semibold" title={title} />
    <RichText
      content={description}
      className="leading-relaxed lg:col-span-5 xl:pt-5"
    />
  </>
);

export default HeroResearch;
